"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1063-563H937V637h-2000z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 129,
    width: 56,
    height: 56,
    rx: 4,
    transform: "translate(-291 -150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25-21h48v56h-48c-6.627 0-12-5.373-12-12V-9c0-6.627 5.373-12 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.806 6.64l6.87 6.75.01.009a1.167 1.167 0 001.639-.013l4.12-4.12a1.167 1.167 0 00-.006-1.657L6.592.875c-.01-.011-.02-.022-.032-.032A2.188 2.188 0 005.165.271H1.378C.734.271.212.794.212 1.438l.004 3.789a2.207 2.207 0 00.59 1.414zm2.03-2.869a.875.875 0 111.75 0 .875.875 0 01-1.75 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
var _default = exports["default"] = SvgComponent;